import React, { FC, memo } from 'react';

import { DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';
import ReportSelectionHeader from '../../ReportSelectionHeader';
import type { PromoSelectionHeaderProps } from './types';

import styles from './index.module.scss';

const PromoSelectionHeader: FC<PromoSelectionHeaderProps> = ({
  hasUnselectedPromos,
  isSelectionActionPending,
  selectedCount,
  onSelectAll,
  onReset,
}) => (
  <ReportSelectionHeader
    className={styles.header}
    resetAction={{
      isDisabled: selectedCount === 0 || isSelectionActionPending,
      testId: DATA_TEST_IDS.AUDIO_REPORT_PROMOS_RESET,
      text: TEXTS.AUDIO_REPORT_PROMOS_RESET,
      onClick: onReset,
    }}
    selectAllAction={
      hasUnselectedPromos
        ? {
            isDisabled: isSelectionActionPending,
            testId: DATA_TEST_IDS.AUDIO_REPORT_PROMOS_SELECT_ALL,
            text: TEXTS.AUDIO_REPORT_PROMOS_SELECT_ALL,
            onClick: onSelectAll,
          }
        : undefined
    }
    selectedCount={TEXTS.AUDIO_REPORT_PROMOS_SELECTED_COUNT(selectedCount)}
    selectedCountTestId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_SELECTED_COUNT}
    testId={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_SELECTION_HEADER}
  />
);

export default memo(PromoSelectionHeader);
